import { Grid, Button, TextField } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import { selectClienteTarget, CambiarFechaCustomAction } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { catRoles } from "../../../constant/catRoles"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import dayjs from 'dayjs'
import PickerMod from "../../../global/PickersMod"

export const FModalCambioFechaStyle = makeStyles((theme) => ({
    modalBotonesCenter: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "1rem"
    },
    textField : {
        width: "90%",
        marginLeft: "10px",
        marginBottom: "1rem"
    },
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        maxHeight: "80vh",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),

    },
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
}));

const ModalCambioFecha = () => {
    const { profile } = useSelector(store => store.logeo)
    const { cliente, referencia } = useSelector(store => store.cliente)
    const dispatch = useDispatch()
    const classes = FModalCambioFechaStyle()
    const [open, setOpen] = useState()
    const [selectDay, setSelectedDate] = useState(dayjs());
    const [montoUnitario, setMontoUnitario] = useState(0)
    const handleChangeSalida = (value) => {
        setSelectedDate(value)
    }
    const handleChangeValorUnitiario = (value) => {
        setMontoUnitario(value)
    }
    const handleSubmit = (event) => {
        event.preventDefault()
        DialogMessage.fire({
            title: `Cambio de fecha custom`,
            text: `¿Esta seguro de cambiar la fecha de salida de la referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(CambiarFechaCustomAction({ fechaSalida: dayjs(selectDay).format('MMDDYYYY'), montoUnitario: Number(montoUnitario), referencia: referencia })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    handleClose()
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const handleClose = () => {
        setOpen(false)
        setSelectedDate(dayjs())
        setMontoUnitario(0)
    }
    const handleOpen = () => {
        setOpen(true)
        setSelectedDate(dayjs())
        setMontoUnitario(0)
    }

    if (profile.Rol?.Id === catRoles.DEVELOPER) return (
        <>
            <Button
                onClick={handleOpen}
                variant="contained"
                color="primary"
            >
                Custom Fecha Salida
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal handleClose={handleClose} titulo={`Custom Cambiar Fecha Salida`} />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="input-monto-unitario"
                            label="Monto unitario"
                            type="number"
                            variant="outlined"
                            name="montoUnitario"
                            value={montoUnitario}
                            onChange={(event) => {
                                handleChangeValorUnitiario(event.target.value);
                            }}
                            className={classes.textField}
                        />
                    </Grid>
                    <Grid item xs={11}>
                        <PickerMod
                             id={"Fecha-de-salida-custom"}
                             label={"Fecha de salida"}
                             disablePast={false}
                             disableFuture={false}
                             selectedDate={selectDay}
                             setSelectedDate={handleChangeSalida}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Agregar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </>

    )
    return null
}
export default ModalCambioFecha